export class Relatorio {
  Id: number;
  Nome: string;
  Descricao: string;
}
